var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNewAndImproved = function SvgNewAndImproved(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0dbd8b",
    fillOpacity: 0.1,
    d: "M24 12a12 12 0 0 1-12 12A12 12 0 0 1 0 12 12 12 0 0 1 12 0a12 12 0 0 1 12 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0dbd8b",
    d: "M20 12a8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8 8 8 0 0 1 8 8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNewAndImproved);
export { ForwardRef as Icon };
export default "img/element-icons/new-and-improved.65a63c7.svg";